const optionsAutreUnits = [{
  label: 'm⁶',
  value: 'm6'
}, {
  label: 'N/A',
  value: 'NA'
}];

export default optionsAutreUnits;
